import { render, staticRenderFns } from "./returnVisitDetail.vue?vue&type=template&id=f12e2b66&scoped=true&"
import script from "./returnVisitDetail.vue?vue&type=script&lang=tsx&"
export * from "./returnVisitDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./returnVisitDetail.vue?vue&type=style&index=0&id=f12e2b66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12e2b66",
  null
  
)

export default component.exports